// import components
import { Box, styled } from '@mui/material';

export const StyledMonthOrWeekRangeBox = styled(Box)(({ theme }) => ({
  height: theme.spacing(10)
}));
